import { SerializedError } from '@reduxjs/toolkit';

export enum StateStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  SUCCESS = 'success',
  FAILED = 'failed',
}
export interface BaseInitialState {
  error: SerializedError | null;
  status: StateStatus;
}

export enum DeviceManagedState {
  MANAGED = 'managed',
  NOT_MANAGED = 'notManaged',
}
